"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedExchangeRateResponseDto = exports.mockedExchangeRate = void 0;
const common_interfaces_1 = require("../../common-interfaces");
exports.mockedExchangeRate = {
  [common_interfaces_1.Currency.euro]: 1,
  [common_interfaces_1.Currency.dollar]: 1.09,
  [common_interfaces_1.Currency.ruble]: 79.59,
  [common_interfaces_1.Currency.euro]: 3.82
};
exports.mockedExchangeRateResponseDto = {
  id: 1,
  currency: common_interfaces_1.Currency.dollar,
  rate: exports.mockedExchangeRate[common_interfaces_1.Currency.dollar],
  createdAt: new Date(),
  updatedAt: null
};